import LiveCaller from '../LiveCaller'

const ApiService = {
    async logOut() {
        try {
            // Call the logout endpoint to invalidate tokens on the server
            await LiveCaller.request().post('/oauth/logout')
        } catch (error) {
            // Continue with logout even if the API call fails
            console.error('Logout API error:', error)
        } finally {
            // Always clear local storage and redirect
            LiveCaller.app.$storage.remove('oauth')
            LiveCaller.app.$storage.remove('oauth_state')
            // Redirect to signin page instead of landing page
            window.location = `${LiveCaller.config.get('app.baseURL')}/signin`
        }
    },
}

export default ApiService
